<template>
  <div class="container-fluid mt-3">
    <div class="user-type">
      <div class="row p-3">
        <div class="col col-sm-10">
          <h3>USER TYPE LIST</h3>
        </div>

        <div class="col col-sm-2">
          <button
            type="button"
            class="btn btn-outline-success "
            data-toggle="modal"
            data-target="#createUserTypeModal"
          >
            ADD NEW
          </button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-hover table-bordered">
          <thead class="table-header">
            <tr>
              <th scope="col">
                #
              </th>
              <th scope="col">
                Code
              </th>
              <th scope="col">
                Name
              </th>
              <th scope="col">
                Status
              </th>
              <th scope="col">
                Date Created
              </th>
              <th scope="col">
                Date Update
              </th>
              <th
                scope="col"
                class="col-actions"
              >
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(userType, index) in userTypes"
              :key="userType.id"
            >
              <th scope="row">
                {{ index+1 }}
              </th>
              <td>{{ userType.code }}</td>
              <td>{{ userType.name }}</td>
              <td>{{ userType.status ? 'ACTIVE':'INACTIVE' }}</td>
              <td>{{ userType.created_at | moment('D MMM YYYY hh:m A') }}</td>
              <td>{{ userType.updated_at | moment('D MMM YYYY hh:m A') }}</td>
              <td>
                <!-- Button trigger modal -->
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm action font-weight-bolder"
                  data-toggle="modal"
                  data-target="#userTypeModal"
                  @click="showUserTypeId(userType.id)"
                >
                  <i class="fa fa-eye small" />
                  view
                </button>
                            &nbsp;
                <button
                  class="btn btn-outline-danger btn-sm action font-weight-bolder"
                  @click="removeUserType(userType.id)"
                >
                  <i
                    class="fa fa-trash-alt small"
                    title="delete"
                  />
                  delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

    import {mapActions,mapGetters} from 'vuex';
    import {formMixins} from '../../../mixins/formMixins';

    export default {
        mixins: [formMixins],
        name: 'IndexUserType',
        methods:{
            ...mapActions([
                'getAllUserTypes',
                'viewUserType',
                'deleteUserType',
            ]),
            showUserTypeId(id){
                this.viewUserType(id);
            },

            async removeUserType(id) {
                if(await this.deleteAlert('Are you sure you want to remove this record.?')){
                    this.deleteUserType(id);
                }
            },
        },

        computed: {
            ...mapGetters([ 'userTypes', 'userType', ])
        },
        created(){
            this.getAllUserTypes();
        },

        mounted:function() {
            $('#myModal').modal({backdrop: 'static', keyboard: false})
        },
    };
</script>

<style scoped>

    /* todo make some of the following styles.*/
    .action{
        font-size: 0.8em;
    }


    .table-responsive tr{
        text-align: center;
    }

</style>
